<script lang="ts">
// Tailwind needs whole class strings.
const COLUMNS_CLASS_MAP: Record<number, string> = {
    1: 'sm:grid-cols-1',
    2: 'sm:grid-cols-2',
    3: 'sm:grid-cols-3',
};
</script>

<script setup lang="ts">
// PROPS
interface Props {
    points?: StoryblokUiPageFeature[];
}

const { points = [] } = defineProps<Props>();

// DATA
const gridClasses = computed<string>(() => COLUMNS_CLASS_MAP[points.length] ?? 'sm:grid-cols-3');
</script>

<template>
    <ul v-if="points.length" class="grid w-full grid-cols-1 gap-4" :class="gridClasses">
        <li v-for="point in points" :key="point._uid" class="text-center">
            <StoryblokComponent :blok="point" />
        </li>
    </ul>
</template>
